/**
 * @override
 * Override standard fragment to include body field with links.
 * Links are needed to render embedded entries/assets in rich text.
 */

import gql from 'graphql-tag';

import {BaseAccordionFragment} from '@amblique/contentful/app/contentful/fragments/accordion/base-accordion.fragment';

export const AccordionFragment = gql`
  ${BaseAccordionFragment}

  fragment AccordionFragment on Accordion {
    ...BaseAccordionFragment

    body {
      json
      links {
        entries {
          block {
            __typename
            sys {
              id
            }
          }
        }
        assets {
          block {
            sys {
              id
            }
            contentType
            description
            fileName
            height
            width
            size
            title
            url
          }
        }
      }
    }
  }
`;
